import { useGlobMap } from 'liyu-pc-base/init-plugin';
import type { GridConfig } from 'liyu-pc-base/typing';
import { markRaw } from 'vue';
const custom_config: { [key: string]: any } = {};

const get_custom_config = async (key: string) => {
  if (Object.keys(custom_config).length > 0) {
    if (custom_config[key]) {
      const obj = await custom_config[key]();
      return obj.default;
    } else {
      const obj = await custom_config['default']();
      return obj.default;
    }
  }
  const allComponents: any = import.meta.glob('liyu-pc-base/components/gridPage/config/*/*.ts', {
    eager: false,
  });
  const customComponents = useGlobMap('gridPage');
  Object.assign(allComponents, customComponents);
  for (const full_file_name in allComponents) {
    const file_name_list = full_file_name.split('/');
    const file_name = file_name_list[file_name_list.length - 1].replace('.ts', '');
    custom_config[file_name] = allComponents[full_file_name];
  }

  if (custom_config[key]) {
    const obj = await custom_config[key]();
    return obj.default;
  } else {
    const obj = await custom_config['default']();
    return obj.default;
  }
};
const process_config = (config: any) => {
  if (config.items) {
    for (const item of config.items) {
      if (item.component) {
        item.component = markRaw(item.component);
      }
    }
  }
};
export const getGridConfig = async (
  key: string,
  { context, eventBus },
): Promise<{ config: GridConfig }> => {
  const configFunc = await get_custom_config(key);
  const local_config = configFunc({ menu_flag: key, context, eventBus });
  process_config(local_config);

  return { config: local_config };
};
